import { CircularProgress, Container } from '@mui/material';
import Grid from 'components/core/Grid';

import { CenteredGrid } from 'scenes/guest/views/GuestDashboard/styles';

interface Props {
  height?: string;
  size?: number;
  thickness?: number;
}

export const LoadingIndicator = ({ height = '100vh', size = 32, thickness = 2 }: Props) => {
  return (
    <Container style={{ height }}>
      <CenteredGrid style={{ height }} container direction="column" alignItems="center" justifyContent="center">
        <Grid item>
          <CircularProgress size={size} thickness={thickness} />
        </Grid>
      </CenteredGrid>
    </Container>
  );
};
